/* Edge — Keani Unehara */
(function () {
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Menu */
  var menu = document.querySelector('[data-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  if (menu && openBtn) {
    var close = menu.querySelector('[data-menu-close]');
    openBtn.addEventListener('click', function () { menu.classList.add('is-open'); openBtn.setAttribute('aria-expanded', 'true'); close.focus(); });
    close.addEventListener('click', function () { menu.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close.click(); });
  }

  /* Home filmstrip */
  var hero = document.querySelector('[data-strip]');
  if (hero) {
    var track = hero.querySelector('[data-strip-track]');
    var items = Array.prototype.slice.call(hero.querySelectorAll('.strip__item'));
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-thumb]'));
    var thumbsBox = hero.querySelector('.thumbs');
    var view = hero.querySelector('[data-view]');
    var count = hero.querySelector('[data-count]');
    var sNum = hero.querySelector('[data-s-num]'), sTitle = hero.querySelector('[data-s-title]'), sFrom = hero.querySelector('[data-s-from]'), sImg = hero.querySelector('[data-s-img]');
    var n = items.length, active = parseInt(hero.getAttribute('data-start'), 10) || 0;

    // Mobile: the big photo (and its caption) is a link to the print
    var sLink = null;
    if (sImg) {
      sLink = document.createElement('a');
      sLink.className = 'stage__link';
      sLink.style.display = 'contents';
      sImg.parentNode.insertBefore(sLink, sImg);
      sLink.appendChild(sImg);
      sImg.style.transition = 'opacity 400ms ease';
    }
    var sCap = hero.querySelector('.stage__cap');
    if (sCap) { sCap.style.cursor = 'pointer'; sCap.addEventListener('click', function () { location.href = items[active].dataset.url; }); }

    // Auto-advance: one print every few seconds, paused while the visitor is engaged or the hero is off screen
    var DELAY = 5000, timer = null, paused = false, inView = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var play = function () {
      clearTimeout(timer);
      if (reduce || paused || !inView || document.hidden || n < 2) return;
      timer = setTimeout(function () { set(active + 1, true); }, DELAY);
    };

    // Position the strip from the FINAL sizes (not mid-transition DOM sizes), so it moves once, smoothly.
    var center = function () {
      if (!n || window.innerWidth < 750) return;
      var hA = Math.min(400, window.innerHeight * 0.46), hS = 112, gap = 10, m = 28;
      var x = 0;
      for (var k = 0; k < active; k++) x += hS * (parseFloat(items[k].dataset.r) || 1.33) + gap;
      x += m + (hA * (parseFloat(items[active].dataset.r) || 1.33)) / 2;
      var wrapW = track.parentElement.clientWidth;
      track.style.transform = 'translateX(' + (wrapW / 2 - x) + 'px)';
    };
    var paint = function () {
      var a = items[active];
      sNum.textContent = '(' + a.dataset.num + ')';
      sTitle.textContent = a.dataset.title + (a.dataset.series ? ', ' + a.dataset.series : '');
      var from = a.querySelector('.strip__cap .mute'); sFrom.textContent = from ? from.textContent : '';
      if (a.dataset.src) { sImg.src = a.dataset.src; sImg.alt = a.dataset.title; }
    };
    var set = function (i, auto) {
      if (!n) return;
      active = (i + n) % n;
      items.forEach(function (el, k) { el.classList.toggle('is-on', k === active); el.setAttribute('aria-pressed', k === active ? 'true' : 'false'); });
      thumbs.forEach(function (el, k) { el.setAttribute('aria-pressed', k === active ? 'true' : 'false'); });
      var a = items[active];
      view.href = a.dataset.url;
      if (sLink) { sLink.href = a.dataset.url; sLink.setAttribute('aria-label', 'View ' + a.dataset.title); }
      count.textContent = pad2(active + 1) + ' / ' + pad2(n);
      // mobile: soft cross-fade when it advances on its own
      if (auto && sImg && window.innerWidth < 750 && a.dataset.src) {
        var want = active, pre = new Image(), faded = false, ready = false;
        var swap = function () { if (faded && ready && want === active) { paint(); sImg.style.opacity = '1'; } };
        pre.onload = pre.onerror = function () { ready = true; swap(); };
        pre.src = a.dataset.src;
        sImg.style.opacity = '0';
        setTimeout(function () { faded = true; swap(); }, 400);
      } else { paint(); sImg && (sImg.style.opacity = '1'); }
      var nx = items[(active + 1) % n]; if (nx && nx.dataset.src) { (new Image()).src = nx.dataset.src; }
      // keep the active thumbnail in view without ever scrolling the page
      var th = thumbs[active];
      if (th && thumbsBox && window.innerWidth < 750) {
        thumbsBox.scrollTo({ left: th.offsetLeft - (thumbsBox.clientWidth - th.offsetWidth) / 2, behavior: 'smooth' });
      }
      center();
      play();
    };
    items.forEach(function (el, k) { el.addEventListener('click', function () { if (k === active) { location.href = el.dataset.url; } else { set(k); } }); });
    thumbs.forEach(function (el, k) { el.addEventListener('click', function () { set(k); }); });
    hero.querySelector('[data-prev]').addEventListener('click', function () { set(active - 1); });
    hero.querySelector('[data-next]').addEventListener('click', function () { set(active + 1); });
    document.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') set(active + 1);
      if (e.key === 'ArrowLeft') set(active - 1);
    });
    var sx = null, sy = null;
    hero.addEventListener('touchstart', function (e) { paused = true; clearTimeout(timer); sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchcancel', function () { paused = false; sx = sy = null; play(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      paused = false;
      if (sx === null) { play(); return; }
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      // horizontal swipe only; a tap still opens the print
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && !e.target.closest('.thumbs')) { e.preventDefault(); set(active + (dx < 0 ? 1 : -1)); }
      else play();
      sx = sy = null;
    });
    // hold still only while a keyboard user is inside the hero (clicks and taps just restart the count)
    hero.addEventListener('focusin', function (e) {
      var kb = false; try { kb = e.target.matches(':focus-visible'); } catch (x) {}
      if (kb) { paused = true; clearTimeout(timer); }
    });
    hero.addEventListener('focusout', function () { paused = false; play(); });
    document.addEventListener('visibilitychange', play);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; play(); }, { threshold: 0.4 }).observe(hero);
    }
    window.addEventListener('resize', center);
    // first position without animation
    track.style.transition = 'none';
    set(active);
    void track.offsetWidth;
    track.style.transition = '';
  }

  /* Product: bracket options -> variant */
  var pdp = document.querySelector('[data-pdp]');
  var json = document.querySelector('[data-pdp-json]');
  if (pdp && json) {
    var data = JSON.parse(json.textContent);
    var btns = Array.prototype.slice.call(pdp.querySelectorAll('[data-opt]'));
    var rows = Array.prototype.slice.call(pdp.querySelectorAll('[data-optrow]'));
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEls = pdp.querySelectorAll('[data-price], [data-price-m]');
    var add = pdp.querySelector('[data-add]');
    var img = pdp.querySelector('[data-pdp-img]');
    var underL = pdp.querySelector('[data-under-l]'), underR = pdp.querySelector('[data-under-r]');
    var note = pdp.querySelector('[data-note]');
    var sel = [];
    btns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') sel[+b.dataset.opt] = b.dataset.val; });

    var find = function (s) { return data.variants.filter(function (v) { return v.options.every(function (o, i) { return s[i] === undefined || o === s[i]; }); }); };
    var render = function () {
      for (var i = 1; i < rows.length; i++) {
        var ok = find(sel.slice(0, i).concat([sel[i]])).length > 0;
        if (!ok) { var first = find(sel.slice(0, i))[0]; if (first) sel[i] = first.options[i]; }
      }
      btns.forEach(function (b) {
        var i = +b.dataset.opt, trial = sel.slice(0, i).concat([b.dataset.val]);
        b.hidden = find(trial).length === 0;
        b.setAttribute('aria-pressed', sel[i] === b.dataset.val ? 'true' : 'false');
      });
      rows.forEach(function (row) { var vis = row.querySelectorAll('[data-opt]:not([hidden])').length; row.hidden = vis < 2 && +row.dataset.optrow > 0; });
      var v = find(sel)[0];
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price; });
      add.disabled = !v.available;
      var size = v.options[1] || '';
      var digital = !v.shipping;
      if (img) img.style.setProperty('--w', (data.widths[size] || 520) + 'px');
      underL.textContent = digital ? 'Digital file' : size + ' art print, unframed';
      underR.textContent = digital ? 'Emailed after purchase' : 'Printed to order';
      note.textContent = digital ? data.noteDigital : data.notePrint;
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { sel[+b.dataset.opt] = b.dataset.val; render(); }); });
    render();
  }
})();
